import React, {Component} from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from 'reactstrap';
import {Link} from 'react-router-dom';
import {ACTIONS, EVENTS} from "react-joyride/es/constants";
import Joyride from 'react-joyride';
import ReactToPrint from "react-to-print";
import ViewForPrinting from '../CaseDetails/ViewForPrinting';

class ModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            steps: [
                {
                    target: '.booking-form',
                    content: 'Fill in the form to book your case.',
                    placement: 'bottom',
                    disableBeacon: true
                },
                {
                    target: '.todays-date',
                    content: 'This is today\'s date.',
                    placement: 'auto'
                },
                {
                    target: '.sending-date',
                    content: 'Date of sending the case to the laboratory. This date should be at least 10 days before the requested return date.',
                    placement: 'auto'
                },
                {
                    target: '.return-date',
                    content: 'The date the case is requested to be ready.',
                    placement: 'auto'
                },
                {
                    target: '.booking-add-new',
                    content: 'You can add your patients from here.',
                    placement: 'auto'
                }
            ],
            isViewForPrintingMounted: false,
            run: false
        }
    }

    componentDidMount() {
        this.setState({
            run: !this.props.guideRun
        });
    }

    static defaultProps = {
        joyride: {}
    };

    handleJoyrideCallback (data) {
        const {joyride} = this.props;
        const {action, type} = data;

        if (action === ACTIONS.SKIP) {
            this.props.handleUpdateGuide();
            this.props.handleClose();
        }  else if (type === EVENTS.TOUR_END) {
            this.props.handleUpdateGuide();
            this.props.handleClose();
            this.setState({run: false})
        }

        if (typeof joyride.callback === "function") {
            joyride.callback(data);
        }
    };

    handleClick(event){
        this.props.onConfirm(() => {
            this.props.saveChanges(event)
        });
    }

    handleClosePrint = () => {
        setTimeout(() => this.props.handleClose());
    }

    render() {
        const joyrideProps = {
            ...this.state,
            ...this.props.joyride
        };
        if (this.props.addBookingForm) {
            return (
                <Modal dialogClassName={this.props.dialogClassName} className={this.props.className} show={this.props.show} onHide={this.props.handleClose}>
                    <div className={this.props.modalHeaderStyle + " modal-header"}>
                        <Modal.Title className="modalTitle">{this.props.headerTitle}</Modal.Title>
                        <span disabled={this.props.guideRun === false} className="kr kr-close" onClick={this.props.handleClose} />
                        {this.props.isSubcase ? <div className="title-subcase">Subcase Of {this.props.modalTitleLeft}</div> : ''}
                    </div>
                    {
                        (this.props.isAdmin === false) ? <Joyride
                            scrollToFirstStep
                            showSkipButton
                            showProgress
                            disableCloseOnEsc
                            disableOverlayClose
                            disableScrolling
                            {...joyrideProps}
                            autoStart={true}
                            continuous={true}
                            callback={(data) => this.handleJoyrideCallback(data)}
                            styles={{
                                options: {
                                    primaryColor: "#099"
                                }
                            }}
                        /> : ''
                    }
                    <Modal.Body className="booking-form">
                        { this.props.modalBody }
                    </Modal.Body>
                    <Modal.Footer>
                        <button disabled={this.props.guideRun === false} className="btn btn-outline" onClick={this.props.handleClose}>{this.props.cancelButtonName ?  this.props.cancelButtonName : 'Cancel'}</button>
                        <button disabled={this.props.guideRun === false || this.props.saveDisabled} className='btn btn-primary' onClick={this.props.buttonFunction}>{ this.props.buttonText }</button>
                    </Modal.Footer>
                </Modal>
            );
        } else if (this.props.infoModal === true) {
            return (
                <Modal bsSize="large" dialogClassName={this.props.dialogClassName} className="" show={this.props.show} onHide={this.props.handleClose}>
                    <div className={this.props.modalHeaderStyle + " modal-header"}>
                        <Modal.Title className={this.props.modalTitle || "modalTitle"}>{ this.props.headerTitle }</Modal.Title>
                        <span className="kr kr-close" onClick={this.props.handleClose} />
                    </div>
                    <Modal.Body>
                        { this.props.modalBody }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-outline" onClick={this.props.handleClose}>{this.props.cancelButtonName ?  this.props.cancelButtonName : 'Cancel'}</Button>
                    </Modal.Footer>
                </Modal>
            )
        } else if(this.props.closeModal === true){
            return (
                <Modal bsSize="large" dialogClassName={this.props.dialogClassName} className="" show={this.props.show} onHide={this.props.handleClose}>
                    <div className={this.props.modalHeaderStyle + " modal-header"}>
                        <Modal.Title className={this.props.modalTitle || "modalTitle"}>{ this.props.headerTitle }</Modal.Title>
                        <span className="kr kr-close" onClick={this.props.handleClose} />
                    </div>
                    <Modal.Body>
                        { this.props.modalBody }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-outline" onClick={this.props.handleClose}>Close</Button>
                    </Modal.Footer>
                </Modal>
            )
        } else if (this.props.printCase === true) {
            const data = {
                implantsPartObject: {
                    1: {name: 'Impression coping ', number: 0},
                    2: {name: 'Impression screw ', number: 0},
                    3: {name: 'Lab analog ', number: 0},
                    4: {name: 'Prosthetic screw ', number: 0},
                    5: {name: 'Abutment/Ti', number: 0},
                    6: {name: 'Other ', number: 0}
                },
                enclosedBoxObject: {
                    1: {name: 'Impression'},
                    2: {name: 'Antagonist model/impression'},
                    3: {name: 'Bite'},
                    4: {name: 'Pre-op/temp model/impression'},
                    5: {name:  'Optical scan'},
                    6: { name: 'Implant parts' },
                    7: { name: 'Other ' }
                }
            };
            if (this.props.caseDetails) {
                const caseDetails = this.props.caseDetails.caseDetails;
                const dentistName =  caseDetails.dentist_id.first_name + ' ' + caseDetails.dentist_id.last_name;
                const patientName = (this.props.isAdmin) ? caseDetails.patient.first_name + ' ' + caseDetails.patient.last_name : caseDetails.patient;
                data.dentistName =  dentistName;
                data.patientName = patientName;
                data.patient = {
                    bookingId: caseDetails.id,
                    sendingDate: caseDetails.sending_date,
                    status: caseDetails.status,
                    dateOfSubmission: caseDetails.date_of_submission,
                    dateOfReturn: caseDetails.date_of_return,
                    patientId: caseDetails.patient.id,
                    numberOfUnits: caseDetails.number_of_units,
                    type: caseDetails.type,
                    notes: caseDetails.notes,
                    color: caseDetails.color,
                    signature: caseDetails.signature,
                    license: caseDetails.license,
                    implant: caseDetails.implant.toString(),
                    implantType: caseDetails.implant_type,
                    implantSize: caseDetails.implant_size,
                    enclosedBox: this.props.caseDetails.enclosedBox,
                    implantParts: this.props.caseDetails.implantParts
                }
            }
            return (
                <div>
                    <Modal dialogClassName={this.props.dialogClassName} show={this.props.show} onHide={this.props.handleClose}>
                        <div className={this.props.modalHeaderStyle + " modal-header"}>
                            <Modal.Title className="modalTitle">{ this.props.headerTitle }</Modal.Title>
                            <span className="kr kr-close" onClick={this.props.handleClose} />
                        </div>
                        <Modal.Body>
                            { this.props.modalBody }
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className="btn btn-secondary" onClick={this.props.handleClose}>No</Button>
                            <ReactToPrint
                                trigger={() => <Button
                                    disabled={!this.state.isViewForPrintingMounted}
                                    className={(this.props.buttonStyle) ? this.props.buttonStyle : 'btn btn-primary'}
                                >{this.props.buttonText}</Button>
                                }
                                content={() => this.componentRef2}
                                onAfterPrint={this.handleClosePrint}
                                closeAfterPrint={true}
                                removeAfterPrint={false}
                            />
                        </Modal.Footer>
                    </Modal>
                    {
                        (this.props.caseDetails) ? <ViewForPrinting
                            ref={el => (this.componentRef2 = el)}
                            implantsPartObject={data.implantsPartObject}
                            enclosedBoxObject={data.enclosedBoxObject}
                            handleMount={() => this.setState({ isViewForPrintingMounted: true })}
                            handleUnMount={() => this.setState({ isViewForPrintingMounted: false })}
                            patient={data.patient}
                            patientName={ data.patientName }
                            dentistName={ data.dentistName }
                            isAdmin={this.props.isAdmin}
                        /> : ''
                    }
                </div>
            )
        } else if (this.props.registeredUser === true) {
            return (
                <Modal show={this.props.show} onHide={this.props.handleClose} backdrop={'static'}>
                    <div className={this.props.modalHeaderStyle + " modal-header"}>
                        <Modal.Title className="modalTitle">{ this.props.headerTitle }</Modal.Title>
                    </div>
                    <Modal.Body>
                        <p>Please, check your email inbox (spam) folder for account activation.
                            <br/>If you have not received the email click
                            <button className="btn-link" onClick={() => this.props.resendEmail()}>here to resend.</button>
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Link className='btn btn-primary' to="sign-in">Sign In</Link>
                    </Modal.Footer>
                </Modal>
            )
        } else if (this.props.isLeaveModal === true){
            return (
                <Modal className="" show={this.props.show} onHide={this.props.handleClose}>
                    <div className={`modal-header ${this.props.modalHeaderStyle}`}>
                        <Modal.Title className="modalTitle">{ this.props.headerTitle }</Modal.Title>
                        <span className="kr kr-close" onClick={this.props.handleClose} />
                    </div>
                    <Modal.Body>
                        Are you sure you want to leave?
                    </Modal.Body>
                    <Modal.Footer className="leave__modal">
                        <button className="btn btn-outline" onClick={this.props.buttonFunction}>{ this.props.buttonText }</button>
                        <button onClick={this.props.handleClose} className="btn btn-primary">Stay</button>
                    </Modal.Footer>
                </Modal>
            );
        } else if (this.props.isPickupModal === true){
            return (
                <Modal show={this.props.show} onHide={this.props.handleClose}>
                    <div className={this.props.modalHeaderStyle + " modal-header"}>
                        <Modal.Title className="modalTitle">{ this.props.headerTitle }</Modal.Title>
                        <span className="kr kr-close" onClick={this.props.handleClose} />
                    </div>
                    <Modal.Body>
                        { this.props.modalBody }
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-outline" onClick={this.props.handleClose}>No</button>
                        <button className="btn btn-primary" onClick={this.props.buttonFunction}>{ this.props.buttonText }</button>
                    </Modal.Footer>
                </Modal>
            );
        } else if (this.props.historyModal === true) {
            return (
                <Modal bsSize="large" className="history__modal" show={this.props.show} onHide={this.props.handleClose}>
                    <div className="modalHeaderDefault modal-header">
                        <Modal.Title className="modalTitle p-0">{ this.props.headerTitle }</Modal.Title>
                        <span className="kr kr-close" onClick={this.props.handleClose} />
                    </div>
                    <Modal.Body>
                        { this.props.modalBody }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="mb-2 btn btn-outline" onClick={this.props.handleClose}>Close</Button>
                    </Modal.Footer>
                </Modal>
            )
        } else if (this.props.visibleImg) {
            return (
                <Modal bsSize="large" className="history__modal" show={this.props.visibleImg} onHide={this.props.handleClose}>
                    <div className="modalHeaderDefault modal-header">
                        <Modal.Title className="modalTitle p-0">{ this.props.headerTitle }</Modal.Title>
                        <span className="kr kr-close" onClick={this.props.handleClose} />
                    </div>
                    <Modal.Body>
                        { this.props.modalBody }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => this.props.onConfirm()} className="btn btn-outline" >No</Button>
                        <Button
                            onClick={(event) => this.handleClick(event)}
                            className="no-shadow-btn btn btn-primary"
                        >
                            Yes
                        </Button>
                    </Modal.Footer>
                </Modal>
            )
        }
        else {
            return (
                <Modal dialogClassName={this.props.dialogClassName} show={this.props.show} onHide={this.props.handleClose}>
                    <div className={this.props.modalHeaderStyle + " modal-header"}>
                        <Modal.Title className="modalTitle">{ this.props.headerTitle }</Modal.Title>
                        <span className="kr kr-close" onClick={this.props.handleClose} />
                    </div>
                    <Modal.Body>
                        {this.props.errorMessage ? <span className="error-message-show">{this.props.errorMessage}</span> : ''}
                        {this.props.showRow ? <pre>{this.props.modalBody}</pre> : this.props.modalBody }
                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick={this.props.handleClose} className={"no-shadow-btn btn btn-outline"}>{this.props.cancelButtonName ?  this.props.cancelButtonName : 'Cancel'}</button>
                        <button
                            className={ (this.props.buttonStyle) ? this.props.buttonStyle : 'btn btn-primary' }
                            color=""
                            disabled={this.props.buttonDisabled}
                            onClick={this.props.buttonFunction}>
                            { this.props.buttonText }
                        </button>
                    </Modal.Footer>
                </Modal>
            );
        }

    }
}

export default ModalComponent



// WEBPACK FOOTER //
// ./src/components/Modal/index.js